module.exports = __webpack_public_path__ + "static/media/smartphones.b3dd3c4a.jpg";